const ServerScreenState = () => (typeof (global) !== 'undefined' && typeof (global.ServerScreenState) !== 'undefined' ? global.ServerScreenState : null);
export default ServerScreenState;
